import { MuiAlert, Tooltip, Typography, strIsNullOrEmpty } from '@fox/atoms';
import { FlexColumnSpaced } from '@fox/layout';
import * as moment from 'moment';
import { Transition } from 'react-transition-group';
import { TransitionStatus } from 'react-transition-group/Transition';
import { useTheme } from 'styled-components';
import { Compact, InnerCompact, transitionStyles } from '../../NewsList/shared';
import { SwiftFoxEvent } from '../events/contracts';
import { RsvpButton } from '../events/rsvp-button';
import { useEventListContext } from './event-list-context';
import { getEventType } from './util';

export function CompactEventItem({ event }: { event: SwiftFoxEvent }) {
	const { hideThumbnail, defaultThumbnailUrl, refetch, rsvpOptions } = useEventListContext();
	const startDate = event.eventStart ? moment(event.eventStart).format('h.mm a, DD MMM YYYY') : '';
	const type = getEventType(event);
	const theme = useTheme();
	return (
		<Transition timeout={200} in={true} appear={true}>
			{(state: TransitionStatus) => {
				return (
					<Compact style={{ ...transitionStyles[state] }} hasImage={!hideThumbnail && !strIsNullOrEmpty(defaultThumbnailUrl)}>
						{!hideThumbnail && (event.coverImageUrl || defaultThumbnailUrl) ? (
							<img
								src={event.coverImageUrl ?? defaultThumbnailUrl}
								style={{
									borderRadius: '10px 10px 0px 0px',
									width: '100%',
									height: '200px',
									objectFit: 'cover'
								}}
							/>
						) : null}
						<InnerCompact>
							<Typography
								style={{
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									fontSize: '0.8rem'
								}}
							>
								<span style={{ color: theme.colors.primary, fontWeight: 'bold' }}>{type}</span>
								{startDate ? <span> | {startDate}</span> : null}
							</Typography>
							<div style={{ height: '8.25rem', marginTop: '0.25rem' }}>
								<Tooltip title={event.name}>
									<Typography
										variant="h4"
										className="event-title"
										style={{
											fontSize: '1.3rem',
											fontWeight: 'bold',
											height: '4.5rem',
											lineHeight: 'initial'
										}}
									>
										{event.name}
									</Typography>
								</Tooltip>
								<Tooltip title={event.description}>
									<Typography className="read-more" style={{ fontSize: '1rem', marginTop: '0.5rem', height: '3rem' }}>
										{event.description}
									</Typography>
								</Tooltip>
							</div>
							<FlexColumnSpaced
								style={{
									width: '100%',
									alignItems: 'center',
									justifyContent: 'center',
									marginTop: '1rem'
								}}
							>
								<RsvpButton
									eventStart={event.eventStart}
									isMobile={false}
									eventId={event.id}
									refetch={refetch}
									rsvpFormLink={event.rsvpFormLink}
									availableTickets={event.availableTickets}
								/>
								{!strIsNullOrEmpty(event?.rsvpStatus) ? (
									<MuiAlert severity="success" sx={{ backgroundColor: 'transparent' }}>
										{rsvpOptions?.find(option => option.id === event?.rsvpStatus)?.displayName}
									</MuiAlert>
								) : (
									<div style={{ height: '50px' }} />
								)}
							</FlexColumnSpaced>
						</InnerCompact>
					</Compact>
				);
			}}
		</Transition>
	);
}
